import { IAuthorizationHolder } from './i_authorization_holder';

export class SlotOnlyAuthorizationHolder implements IAuthorizationHolder {
  public id: string;
  public session: string;
  public userId: number;

  public setAuthorization(session: string, id: string, userId: number): void {
    this.session = session;
    this.id = id;
    this.userId = userId;
  }
}
